exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-64478b58] .el-form-item{margin-bottom:15px}", ""]);

// exports
